import React from 'react';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonBackButton,
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonIcon,
  IonText,
  useIonViewWillLeave,
} from '@ionic/react';
import {
  documentOutline,
  personAddOutline,
  cloudDownloadOutline,
} from 'ionicons/icons';
import SnowballMenu from '@/modules/user/SnowballMenu';
import { useContactPicker } from '@/contexts/ContactPickerContext';
import { useAddressBookRestore } from '@/modules/contact/useAddressBookRestore';

const ContactsSettingsHome: React.FC = () => {
  const { isAvailable, canBeEnabled } = useContactPicker();
  const pickerOptionVisible = isAvailable || canBeEnabled;
  const { restore, busy: restoreBusy } = useAddressBookRestore();

  useIonViewWillLeave(() => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  });

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/settings" />
          </IonButtons>
          <IonTitle>Address Book Settings</IonTitle>
          <IonButtons slot="end">
            <SnowballMenu />
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <div style={{ padding: '16px 20px' }}>
          <IonText color="medium">
            <p>
              Your Snowball address book lets you quickly share actions with
              friends and family. How would you like to add contacts?
            </p>
          </IonText>
        </div>
        <IonList>
          <IonItem
            button
            detail
            routerLink="/settings/contacts/import"
            data-testid="settings-contacts-import-item"
          >
            <IonIcon icon={documentOutline} slot="start" />
            <IonLabel>
              <h2>Bulk import from .vcf</h2>
              <p>Copy your contacts from the Contacts app</p>
            </IonLabel>
          </IonItem>
          {pickerOptionVisible && (
            <IonItem
              button
              detail
              routerLink="/settings/contacts/picker"
              data-testid="settings-contacts-picker-item"
            >
              <IonIcon icon={personAddOutline} slot="start" />
              <IonLabel>
                <h2>Device contact picker</h2>
                <p>Pick individual contacts from your device</p>
              </IonLabel>
            </IonItem>
          )}
          <IonItem
            button
            detail={false}
            disabled={restoreBusy}
            onClick={() => restore()}
            data-testid="settings-contacts-restore-item"
          >
            <IonIcon icon={cloudDownloadOutline} slot="start" />
            <IonLabel>
              <h2>Restore from server backup</h2>
              <p>Replace this device's address book with the server copy</p>
            </IonLabel>
          </IonItem>
        </IonList>
      </IonContent>
    </IonPage>
  );
};

export default ContactsSettingsHome;
